/* cart-edit.js: Modal-based cart item editor without touching theme.js */
(function(){
  function ready(fn){
    if (document.readyState === 'complete' || document.readyState === 'interactive') { setTimeout(fn, 0); } else { document.addEventListener('DOMContentLoaded', fn); }
  }

  ready(function(){
  var $ = window.jQuery;
  if (!$ || typeof $ === 'undefined') { return; }

  function getHandleFromUrl(url){
    try {
      if (!url) return '';
      var parts = url.split('/products/');
      if (parts.length < 2) return '';
      return parts[1].split('?')[0].split('#')[0];
    } catch(e){ return ''; }
  }

  function formatMoney(cents){
    try { return theme && theme.Currency && theme.Currency.formatMoney ? theme.Currency.formatMoney(cents, theme.moneyFormat) : (cents/100).toFixed(2); } catch(e){ return (cents/100).toFixed(2); }
  }

  // Helper function to convert color names to CSS color values
  // Uses the same comprehensive color mapping as globo.filter.product.liquid
  function getColorValue(colorName) {
    if (!colorName) return '#cccccc';

    // Convert to lowercase (matches | downcase filter used in templates)
    var color = colorName.toLowerCase().trim();

    // Check if it's already a hex color
    if (color.match(/^#[0-9a-f]{3,6}$/i)) {
      return color;
    }

    // Comprehensive color mapping from globo.filter.product.liquid
    var colorMap = {
      // Basic colors
      'grey': '#bbbdc1',
      'beige': '#c6baaf',
      'beige brown': '#987654',
      'light green': '#aebcbc',
      'green': '#b2bbab',
      'lilac': '#9e94a5',
      'ivory': '#e1d6c6',
      'blue': '#b6c5d9',
      'pink': '#FFC0CB',
      'white': '#ffffff',
      'off white': '#f2f3ee',
      'gold': '#808080',
      'dark grey': '#746c6b',
      'light gray': '#e8e7e3',
      'taupe': '#bbb09f',
      'purple': '#b294a2',
      'sky': '#808000',
      'mint': '#c9e0df',
      'pale brown': '#987654',
      'yellow': '#f8e3a1',
      'brown': '#dab6a4',
      'red': '#800000',
      'multicolor': '#800000',
      'graphite': '#735746',
      'gray': '#cec9c9',
      'cadet blue gray': '#94a3b5',
      'blush pink': '#eed5d4',
      'light ivory': '#eceae8',
      'light blue': '#dce0e4',
      'light beige': '#dcd3d1',
      'powder blue': '#b6c5d9',
      'olive green': '#796e2e',
      'olive brown': '#80724c',
      'mauve brown': '#ac9a90',
      'pale rose': '#e6cec9',
      'sky blue': '#42bff8',
      'light purple': '#d0a0e0',
      'pastel yellow': '#f8e3a1',
      'burgundy': '#910735',
      'offwhite': '#e5e1dc',
      'ice blue': '#edf1f4',
      'ivory beige': '#e7ddd2',
      'dusty pink': '#ddbeb9',
      'pale coral': '#f1ded4',
      'camel': '#dfd7c5',
      'peach': '#f0c1b1',
      'sandy brown': '#c6a88a',
      'mint gray': '#eef2e5',
      'light beige gray': '#d0c4be',
      'rose beige': '#dbc9c8',
      'stone gray': '#bdb5b3',

      // Additional common colors
      'black': '#000000',
      'navy': '#000080',
      'maroon': '#800000',
      'lime': '#00ff00',
      'aqua': '#00ffff',
      'teal': '#008080',
      'silver': '#c0c0c0',
      'orange': '#ffa500'
    };

    // Check for exact match
    if (colorMap[color]) {
      return colorMap[color];
    }

    // Try to match color names with spaces replaced by hyphens (common variation)
    var colorWithHyphens = color.replace(/\s+/g, '-');
    if (colorMap[colorWithHyphens]) {
      return colorMap[colorWithHyphens];
    }

    // Try to match first word only (for multi-word colors)
    var firstWord = color.split(' ')[0];
    if (colorMap[firstWord]) {
      return colorMap[firstWord];
    }

    // Default fallback for unknown colors
    return '#cccccc';
  }

  function renderImages(product){
    var $wrap = $('#cem-images');
    $wrap.empty();
    console.log('Rendering images for product:', product.title);
    console.log('Product images:', product.images);
    
    if (!product || !product.images || !product.images.length) {
      console.log('No images found for product');
      return;
    }
    
    try {
    var img = product.images[0];
      
      // Handle different image formats
      if (typeof img === 'string') {
        console.log('Image is a string URL:', img);
    var html = '<img style="max-width:100%;height:auto" src="'+ img.replace('.jpg','_800x.jpg').replace('.png','_800x.png') +'"/>';
    $wrap.append(html);
  }
      else if (img && img.src) {
        console.log('Image is an object with src:', img.src);
        var html = '<img style="max-width:100%;height:auto" src="'+ img.src.replace('.jpg','_800x.jpg').replace('.png','_800x.png') +'"/>';
        $wrap.append(html);
      }
      else {
        console.log('Image format not recognized:', img);
        // Fallback to a placeholder
        $wrap.append('<div style="width:100%;height:200px;background:#f8f8f8;display:flex;align-items:center;justify-content:center;"><span>No image available</span></div>');
      }
    } catch(e) {
      console.error('Error rendering image:', e);
      $wrap.append('<div style="width:100%;height:200px;background:#f8f8f8;display:flex;align-items:center;justify-content:center;"><span>Error loading image</span></div>');
    }
  }

  function renderOptions(product, selectedVariant){
    var $opts = $('.cem-options');
    $opts.empty();
    if (!product || !product.options) return;
    
    console.log('Rendering options for product:', product.title);
    console.log('Selected variant:', selectedVariant);
    console.log('Product options:', product.options);
    console.log('Product variants:', product.variants);
    
    // Check if we have only one variant with "Default Title"
    if (product.variants.length === 1 && product.variants[0].title === "Default Title") {
      console.log('Product has only one default variant - no options to display');
      $opts.append('<div class="no-options-message">No options available for this product</div>');
      return;
    }
    
    // First, find color/colour options and render them
    var colorOptionFound = false;
    product.options.forEach(function(opt, idx){
      if (opt.name.toLowerCase().indexOf('color') !== -1 || opt.name.toLowerCase().indexOf('colour') !== -1) {
        colorOptionFound = true;
        
        // Get unique values for this option
        var uniqueValues = [];
        (opt.values || []).forEach(function(v) {
          if (uniqueValues.indexOf(v) === -1) {
            uniqueValues.push(v);
          }
        });
        
        console.log('Unique color values:', uniqueValues);
        
        // Don't show color swatch if there is only one color
        if (uniqueValues.length <= 1) {
          return;
        }
        
        var $colorSection = $('<div class="color-section" />');
        var $colorLabel = $('<span class="color-label" />').text(opt.name);
        var $colorOptions = $('<div class="color-options" />');
        
        uniqueValues.forEach(function(v){
          var colorClass = selectedVariant && selectedVariant['option' + (idx+1)] === v ? 'active' : '';

          // Try to find a variant image for this color value across any option position
          var variantImage = '';
          if (product.variants && product.variants.length){
            for (var i = 0; i < product.variants.length; i++){
              var variant = product.variants[i];
              var matchesColor = (variant.option1 === v) || (variant.option2 === v) || (variant.option3 === v);
              if (matchesColor && variant.featured_image && variant.featured_image.src){
                variantImage = variant.featured_image.src;
                break;
              }
            }
          }
          // Fallback to first product image if none on variant
          if (!variantImage && product.images && product.images.length){
            variantImage = (typeof product.images[0] === 'string') ? product.images[0] : (product.images[0].src || '');
          }

          // Build swatch element with solid color only
          var $colorSwatch;
          var colorValue = getColorValue(v);
          $colorSwatch = $('<div class="color-swatch '+ colorClass +'" data-value="'+ v +'" data-position="'+ (idx+1) +'" />').css('background-color', colorValue);
          $colorOptions.append($colorSwatch);
        });
        
        $colorSection.append($colorLabel).append($colorOptions);
        $opts.append($colorSection);
      }
    });
    
    // Then, render size options
    var sizeOptionFound = false;
    product.options.forEach(function(opt, idx){
      if (opt.name.toLowerCase().indexOf('size') !== -1) {
        sizeOptionFound = true;
        var $sizeSection = $('<div class="size-section" />');
        var $sizeLabel = $('<span class="size-label" />').text(opt.name);
        var $sizeList = $('<div class="size-list" />');
        
        // Get unique values for this option
        var uniqueValues = [];
        (opt.values || []).forEach(function(v) {
          if (uniqueValues.indexOf(v) === -1) {
            uniqueValues.push(v);
          }
        });
        
        console.log('Unique size values:', uniqueValues);
        
        uniqueValues.forEach(function(v){
          var sizeClass = selectedVariant && selectedVariant['option' + (idx+1)] === v ? 'active' : '';
          var variantPrice = '';
          var variantDesc = '';
          
          // Find variant with this size to show its price
          if (product.variants) {
            for (var i = 0; i < product.variants.length; i++) {
              var variant = product.variants[i];
              if (variant['option' + (idx+1)] === v) {
                variantPrice = formatMoney(variant.price);
                // Add dimensions if present in the option value
                if (v.indexOf(' - ') !== -1) {
                  variantDesc = v;
                  v = v.split(' - ')[0];
                }
                break;
              }
            }
          }
          
          var $sizeOption = $(
            '<div class="size-option '+ sizeClass +'" data-value="'+ v +'" data-position="'+ (idx+1) +'">' +
              '<span>'+ (variantDesc || v) +'</span>' +
              '<span class="size-price">'+ variantPrice +'</span>' +
            '</div>'
          );
          $sizeList.append($sizeOption);
        });
        
        $sizeSection.append($sizeLabel).append($sizeList);
        $opts.append($sizeSection);
      }
    });
    
    // Finally, render any other options
    product.options.forEach(function(opt, idx){
      if ((opt.name.toLowerCase().indexOf('color') === -1 && opt.name.toLowerCase().indexOf('colour') === -1) && 
          opt.name.toLowerCase().indexOf('size') === -1) {
        var $optionSection = $('<div class="option-section" />');
        var $optionLabel = $('<span class="option-label" />').text(opt.name);
        var $select = $('<select class="option-select" data-position="'+ (idx+1) +'" />');
        
        // Get unique values for this option
        var uniqueValues = [];
        (opt.values || []).forEach(function(v) {
          if (uniqueValues.indexOf(v) === -1) {
            uniqueValues.push(v);
          }
        });
        
        console.log('Unique other values:', uniqueValues);
        
        uniqueValues.forEach(function(v){
          var selected = selectedVariant && selectedVariant['option' + (idx+1)] === v ? 'selected' : '';
          $select.append($('<option '+ selected +' />').attr('value', v).text(v));
        });
        
        $optionSection.append($optionLabel).append($select);
        $opts.append($optionSection);
      }
    });
  }

  function findVariantFromSelections(product){
    if (!product) return null;
    
    console.log('Finding variant from selections for product:', product.title);
    
    // If product has only one variant, return it directly
    if (product.variants.length === 1) {
      console.log('Product has only one variant, returning it directly:', product.variants[0]);
      return product.variants[0];
    }
    
    var selected = [];
    
    // Get all selected options from color swatches, size buttons, and select dropdowns
    for (var i = 1; i <= 3; i++) {
      if ($('.color-swatch.active[data-position="' + i + '"]').length) {
        var colorValue = $('.color-swatch.active[data-position="' + i + '"]').data('value');
        selected.push(colorValue);
        console.log('Selected color option ' + i + ':', colorValue);
      } else if ($('.size-option.active[data-position="' + i + '"]').length) {
        var sizeValue = $('.size-option.active[data-position="' + i + '"]').data('value');
        selected.push(sizeValue);
        console.log('Selected size option ' + i + ':', sizeValue);
      } else if ($('select.option-select[data-position="' + i + '"]').length) {
        var selectValue = $('select.option-select[data-position="' + i + '"]').val();
        selected.push(selectValue);
        console.log('Selected dropdown option ' + i + ':', selectValue);
      }
    }
    
    console.log('All selected options:', selected);
    
    // If no options selected but we have a current variant, return it
    if (selected.length === 0 && $('#CartEditModal').data('currentVariantId')) {
      var currentId = $('#CartEditModal').data('currentVariantId');
      for (var i = 0; i < product.variants.length; i++) {
        if (product.variants[i].id == currentId) {
          console.log('No options selected, returning current variant:', product.variants[i]);
          return product.variants[i];
        }
      }
    }
    
    // If still no selection, return the first available variant
    if (selected.length === 0) {
      for (var i = 0; i < product.variants.length; i++) {
        if (product.variants[i].available) {
          console.log('No options selected, returning first available variant:', product.variants[i]);
          return product.variants[i];
        }
      }
      // If no available variants, return the first one
      console.log('No options selected or available variants, returning first variant:', product.variants[0]);
      return product.variants[0];
    }
    
    // Find variant that matches all selected options
    var found = null;
    
    console.log('Looking for variant with options:', selected);
    console.log('Available variants:', product.variants);
    
    // First try: exact match
    (product.variants || []).some(function(v){
      var opts = [v.option1, v.option2, v.option3].filter(function(x){ return !!x; });
      console.log('Checking variant:', v.title, 'with options:', opts);
      
      var match = true;
      for (var i=0; i<selected.length && i<opts.length; i++){
        if (selected[i] != opts[i]) { 
          match = false; 
          break; 
        }
      }
      if (match){ 
        found = v; 
        console.log('Found exact matching variant:', v);
        return true; 
      }
      return false;
    });
    
    // Second try: check if variant title contains all selected options
    if (!found) {
      console.log('No exact match found, trying title match');
      (product.variants || []).some(function(v){
        var title = v.title.toLowerCase();
        var allOptionsInTitle = true;
        
        for (var i=0; i<selected.length; i++){
          if (selected[i] && !title.includes(selected[i].toLowerCase())) { 
            allOptionsInTitle = false;
            break;
          }
        }
        
        if (allOptionsInTitle) {
          found = v;
          console.log('Found title match variant:', v);
          return true;
        }
        return false;
      });
    }
    
    // Third try: partial match by option position
    if (!found) {
      console.log('No title match found, trying partial match by position');
      
      // Try to match the first option (usually size)
      if (selected.length > 0 && selected[0]) {
        (product.variants || []).some(function(v){
          if (v.option1 && v.option1.toLowerCase().includes(selected[0].toLowerCase())) {
            found = v;
            console.log('Found partial match by first option:', v);
            return true;
          }
          return false;
        });
      }
      
      // If still not found and we have a second option (usually color)
      if (!found && selected.length > 1 && selected[1]) {
        (product.variants || []).some(function(v){
          if (v.option2 && v.option2.toLowerCase().includes(selected[1].toLowerCase())) {
            found = v;
            console.log('Found partial match by second option:', v);
            return true;
          }
          return false;
        });
      }
    }
    
    // If still no match, return the first variant
    if (!found && product.variants.length > 0) {
      found = product.variants[0];
      console.log('No match found, defaulting to first variant:', found);
    }
    
    return found;
  }

  function updatePriceUI(variant, qtyOverride){
    if (!variant) return;
    var qty = parseInt(qtyOverride != null ? qtyOverride : ($('#cem-qty').val() || '1'), 10);
    if (!Number.isFinite(qty) || qty < 1) qty = 1;
    var total = (variant.price || 0) * qty;
    $('.cem-price').html(formatMoney(total));
    var available = !!variant.available || variant.inventory_policy === 'continue' || variant.inventory_management === null;
    var $btn = $('#cem-update-btn');
    $btn.prop('disabled', !available);
  }

  function rebuildCartDom(cart){
    var $tbody = $('#CartProducts');
    var tplSrcEl = $('#CartProductTemplate');
    var tplSrc = tplSrcEl && tplSrcEl.length ? tplSrcEl.html() : '';
    var items = [];
    (cart.items || []).forEach(function(ci, idx){
      var img = ci.image ? ci.image.replace(/(\.[^.]*)$/, '_240x240$1').replace('http:', '') : '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif';
      var props = ci.properties || {};
      try {
        Object.keys(props).forEach(function(k){ if (k.charAt(0) === '_' || !props[k]) delete props[k]; });
      } catch(e){}
      items.push({
        key: ci.key,
        line: idx + 1,
        url: ci.url,
        img: img,
        name: ci.product_title,
        variation: ci.variant_title,
        properties: props,
        itemQty: ci.quantity,
        price: formatMoney(ci.price),
        vendor: ci.vendor,
        linePrice: formatMoney(ci.line_price),
        originalLinePrice: formatMoney(ci.original_line_price),
        discounts: ci.discounts,
        discountsApplied: ci.line_price !== ci.original_line_price,
        handle: (ci.handle || getHandleFromUrl(ci.url)),
        variant_id: (ci.variant_id || ci.id)
      });
    });

    // If we have a template and Handlebars, fully re-render rows
    if ($tbody.length && tplSrc && typeof Handlebars !== 'undefined'){
      try {
        var template = Handlebars.compile(tplSrc);
        $tbody.empty().append(template({ items: items }));
      } catch(e) {}
    } else {
      // Fallback: update existing rows in place by matching item key
      try {
        (cart.items || []).forEach(function(ci){
          var $row = $('.js-cart-edit[data-key="'+ ci.key +'"]').closest('tr.cart__row');
          if (!$row.length) return;
          // Quantity field
          $row.find('input[type="number"]').val(ci.quantity);
          // Line price and original if discounted
          var $totalCell = $row.find('.cart__cell--total');
          if ($totalCell.length){
            var $orig = $totalCell.find('small.cart-item__original-price');
            if (ci.line_price !== ci.original_line_price){
              if (!$orig.length){
                $orig = $('<small class="cart-item__original-price cart__item-total" />');
                $totalCell.prepend($orig);
                $totalCell.prepend('<br>');
              }
              $orig.html('<s>'+ formatMoney(ci.original_line_price) +'</s>');
            } else {
              $orig.remove();
            }
            $totalCell.find('.cart__item-total').last().html(formatMoney(ci.line_price));
            // Refresh discounts list
            $totalCell.find('.cart-item__discount').remove();
            if (ci.discounts && ci.discounts.length){
              ci.discounts.forEach(function(d){
                $('<p class="cart-item__discount cart__item-total" />').text(d.title).appendTo($totalCell);
              });
            }
          }
          // Update edit button data
          var $edit = $row.find('.js-cart-edit');
          $edit.attr('data-variant-id', (ci.variant_id || ci.id));
          $edit.attr('data-qty', ci.quantity);
        });
      } catch(e) {}
    }
    $('#CartSubtotal').html(formatMoney(cart.total_price));
    if (cart.total_discount > 0 && theme && theme.strings && theme.strings.totalCartDiscount){
      $('#cartDiscountTotal').html(theme.strings.totalCartDiscount.replace('[savings]', formatMoney(cart.total_discount)));
    } else {
      $('#cartDiscountTotal').empty();
    }
    // Sync summary totals on the cart page (if present)
    try {
      if (document.getElementById('CartEstimatedTotal')){
        $('#CartEstimatedTotal').html(formatMoney(cart.original_total_price));
      }
      if (document.getElementById('CartTotal')){
        $('#CartTotal').html(formatMoney(cart.total_price));
      }
      if (document.getElementById('CartYouSavedRow')){
        if ((cart.total_discount || 0) > 0){
          $('#CartYouSaved').html('- ' + formatMoney(cart.total_discount));
          $('#CartYouSavedRow').show();
        } else {
          $('#CartYouSavedRow').hide();
        }
      }
    } catch(e){}
    if (window.theme && theme.miniCart && typeof theme.miniCart.updateElements === 'function'){
      theme.miniCart.updateElements();
      if (typeof theme.miniCart.generateCart === 'function') theme.miniCart.generateCart();
    }
  }

  function openModal(handle, currentVariantId, qty, line, key){
    if (!handle) return;
    $.getJSON('/products/' + handle + '.js', function(product){
      try { console.log('[CartEdit] loaded product', handle); } catch(e){}
      var currentVariant = null;
      (product.variants || []).forEach(function(v){ if (v.id == currentVariantId) currentVariant = v; });
      $('#CartEditModal').data('product', product)
                         .data('line', line)
                         .data('key', key)
                         .data('currentVariantId', currentVariantId)
                         .data('selectedVariantId', currentVariantId);
      $('.cem-title').text(product.title);
      $('#cem-qty').val(qty || 1);
      renderImages(product);
      renderOptions(product, currentVariant);
      updatePriceUI(currentVariant || product.variants[0]);
      var $m = $('#CartEditModal');
      if ($m.modal) { $m.modal('show'); } else { $m.show().addClass('show'); }
    });
  }

  $(document).on('click', '.js-cart-edit', function(e){
    e.preventDefault();
    var $el = $(this);
    var handle = $el.attr('data-product-handle') || getHandleFromUrl($el.closest('tr').find('a.cart__image').attr('href'));
    var line = $el.attr('data-line');
    var key = $el.attr('data-key');
    var variantId = $el.attr('data-variant-id');
    var qty = $el.attr('data-qty');
    openModal(handle, variantId, qty, line, key);
  });

  $(document).on('change', '.cart-edit-modal select.option-select', function(){
    var product = $('#CartEditModal').data('product');
    var v = findVariantFromSelections(product);
    if (v){
      $('#CartEditModal').data('selectedVariantId', v.id);
      updatePriceUI(v);
    }
  });

  // Re-evaluate variant when color or size controls exist for the same position
  function reevaluateVariantAndPrice(){
    var product = $('#CartEditModal').data('product');
    var v = findVariantFromSelections(product);
    if (v){
      $('#CartEditModal').data('selectedVariantId', v.id);
      updatePriceUI(v);
    }
  }
  
  // Handle color swatch clicks
  $(document).on('click', '.cart-edit-modal .color-swatch', function(){
    var $this = $(this);
    var position = $this.data('position');
    var value = $this.data('value');
    
    // Update active state
    $('.color-swatch[data-position="' + position + '"]').removeClass('active');
    $this.addClass('active');
    
    // Update the variant selection
    reevaluateVariantAndPrice();
  });
  
  // Handle size option clicks
  $(document).on('click', '.cart-edit-modal .size-option', function(){
    var $this = $(this);
    var position = $this.data('position');
    var value = $this.data('value');
    
    // Update active state
    $('.size-option[data-position="' + position + '"]').removeClass('active');
    $this.addClass('active');
    
    // Update the variant selection
    reevaluateVariantAndPrice();
  });

  // Update modal price when quantity changes
  $(document).on('input change', '#cem-qty', function(){
    var qty = parseInt($(this).val(), 10) || 1;
    var product = $('#CartEditModal').data('product');
    var selectedId = parseInt($('#CartEditModal').data('selectedVariantId'), 10) || parseInt($('#CartEditModal').data('currentVariantId'), 10);
    var variant = null;
    if (product && product.variants){
      for (var i = 0; i < product.variants.length; i++){
        if (product.variants[i].id == selectedId){ variant = product.variants[i]; break; }
      }
    }
    if (variant){ updatePriceUI(variant, qty); }
  });

  $(document).on('click', '#cem-update-btn', function(){
    var $modal = $('#CartEditModal');
    var line = $modal.data('line');
    var currentId = parseInt($modal.data('currentVariantId'), 10);
    var newId = parseInt($modal.data('selectedVariantId'), 10) || currentId;
    var qty = parseInt($('#cem-qty').val(), 10) || 1;
    var $btn = $(this);
    if ($btn.data('loading')) return; $btn.data('loading', true).prop('disabled', true);

    function finalize(){
      $.getJSON('/cart.js', function(cart){
        try { console.log('[CartEdit] final cart', cart); } catch(e){}
        try { window.theme && (theme.cartObject = cart); } catch(e){}
        rebuildCartDom(cart);
        try { if ($modal.modal) { $modal.modal('hide'); } else { $modal.hide().removeClass('show'); } } catch(e){}
        try { $('.modal-backdrop').remove(); $('body').removeClass('modal-open'); } catch(e){}
        try { $('.js-mini-cart').removeClass('active'); } catch(e){}
        try { $('.overlaycart').removeClass('active'); } catch(e){}
        try { $(document).trigger('click'); } catch(e){}
        try {
          document.querySelectorAll('.overlaycart, .cardraw .overlaycart').forEach(function(el){
            el.style.setProperty('opacity','0','important');
            el.style.setProperty('visibility','hidden','important');
            el.style.setProperty('pointer-events','none','important');
          });
        } catch(e){}
        $btn.data('loading', false).prop('disabled', false);
        try {
          // Verify DOM reflects the new variant; if not, force a light reload
          var found = document.querySelector('.js-cart-edit[data-variant-id="'+ newId +'"]');
          if (!found) {
            console.log('[CartEdit] fallback reload to sync UI');
            window.location.reload();
          }
        } catch(e){}
      });
    }

    if (newId === currentId){
      $.ajax({ type:'POST', url:'/cart/change.js', data:{ line: line, quantity: qty }, dataType:'json' })
        .always(finalize);
      return;
    }

    // Use change.js with line key if available to replace in-place without relying on index
    var key = $modal.data('key');
    if (key){
      try { console.log('[CartEdit] replace item via change.js key', key, '->', newId, 'qty', qty); } catch(e){}
      $.ajax({ type:'POST', url:'/cart/change.js', data:{ id: key, quantity: 0 }, dataType:'json' })
        .always(function(){
          $.ajax({ type:'POST', url:'/cart/add.js', data:{ id: newId, quantity: qty }, dataType:'json' })
            .always(finalize);
        });
      return;
    }

    // Fallback: add new then remove old line
    try { console.log('[CartEdit] add variant', newId, 'qty', qty); } catch(e){}
    $.ajax({ type:'POST', url:'/cart/add.js', data:{ id: newId, quantity: qty }, dataType:'json' })
      .done(function(){
        try { console.log('[CartEdit] add success; removing old line', line); } catch(e){}
        $.ajax({ type:'POST', url:'/cart/change.js', data:{ line: line, quantity: 0 }, dataType:'json' })
          .always(finalize);
      })
      .fail(function(xhr){
        try {
          var resp = xhr.responseJSON; alert(resp && resp.description ? resp.description : 'Unable to add selected variant.');
        } catch(e){ alert('Unable to add selected variant.'); }
        $btn.data('loading', false).prop('disabled', false);
      });
  });
  });
})();


